/**
 * ErrorBoundary — catches uncaught render errors and shows a friendly recovery UI
 * instead of a white screen. Reload button + collapsed technical details.
 */
import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { err: null, showDetails: false };
  }
  static getDerivedStateFromError(err) {
    return { err };
  }
  componentDidCatch(err, info) {
    console.error("[ErrorBoundary]", err, info);
  }
  render() {
    if (!this.state.err) return this.props.children;
    return (
      <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center"
           style={{ background: "#0A0F1E", color: "#F7F8FC" }}
           data-testid="error-boundary">
        <p className="text-3xl">😬</p>
        <p className="text-xl font-medium mt-4">Something went wrong</p>
        <p className="text-sm text-slate-400 mt-2 max-w-md">
          Ragnes hit an unexpected error. Reloading usually fixes it — we've logged the trace.
        </p>
        <button data-testid="error-boundary-reload"
                onClick={() => window.location.reload()}
                className="mt-6 px-5 py-2.5 rounded-full text-sm font-medium bg-sky-500 hover:bg-sky-400 text-white">
          Reload app
        </button>
        <button data-testid="error-boundary-toggle-details"
                onClick={() => this.setState({ showDetails: !this.state.showDetails })}
                className="mt-4 text-xs text-slate-500 hover:text-slate-300 underline">
          {this.state.showDetails ? "Hide details" : "Show details"}
        </button>
        {this.state.showDetails && (
          <pre className="mt-4 max-w-xl overflow-auto text-left text-[10px] text-slate-400 bg-slate-900 p-3 rounded"
               data-testid="error-boundary-details">
            {String(this.state.err?.stack || this.state.err)}
          </pre>
        )}
      </div>
    );
  }
}
